import { h } from 'preact';

import HubNavigation from 'components/editor/hubNavigation/hubNavigation';
import EditorContent from 'components/editor/content';
import SelectableSection from 'components/editor/selectableSection';
import RichTextField from 'components/editor/settings/richTextField';
import HTML from 'components/core/html/html';

import s from 'components/editor/pages/focus/contact.sss';

export default class FocusContactEditor extends EditorContent {

	getSectionTitle(section) {
		const events = section?.events?.filter(e => e?.year);
		if (!events?.length) return '';
		const from = events.at(0).year || '';
		const to = events.at(-1).year || '';
		return from === to ? from : `${from}–${to}`;
	}

	renderVisual() {
		const content = this.props.content;
		return (
			<div class={s.visual}>
				<HubNavigation />
				<div class={s.wrapper}>
					<SelectableSection {...this.props} section="/content" class={s.content}>
						<HTML>{content.content}</HTML>
					</SelectableSection>
				</div>
			</div>
		);
	}

	renderSettings() {
		let settingsContent;
		const nav = [{ label: 'Contact', path: '/' }];
		const activeElement = this.props.activeElement;
		if (activeElement === '/content') {
			settingsContent = (
				<RichTextField
					{...this.props}
					class={s.richTextField}
					label="Text"
					path={`${this.props.dataRoot}/content/content`}
					rows={24}
				/>
			);
		}
		return (
			<div class={s.settings}>
				{this.renderSettingsNavigation(nav)}
				{settingsContent}
			</div>
		);
	}
}